import IMask from 'imask';

/**
 * Mask a value using an array of masks
 *
 * @param {Array} maskList
 * @param {string} inputText
 * @returns {String}
 */
const maskInput = (maskList, inputText) => {

    if (!maskList || maskList.length === 0) {
        return inputText;
    }

    const rawText = inputText.replace(/[\D]/g, '');

    // Sort array in descending order and find a valid mask using the input length
    let currentMask = maskList
        .sort((mask1, mask2) => Math.sign(mask2.length - mask1.length))
        .filter(mask => rawText.length >= mask.length);

    if (currentMask.length > 0) {
        currentMask = currentMask.shift();
        let maskDef = { mask: currentMask.pattern };

        if (currentMask.custom && specificMaks[currentMask.custom]) {
            maskDef = specificMaks[currentMask.custom];
        }

        return IMask.pipe(inputText, maskDef);
    }

    return inputText;
}

/**
 * Mask a value using a single pattern
 *
 * @param {string} maskPattern
 * @param {string} inputText
 * @returns {String}
 */
const maskValue = (maskPattern, inputText) => {

    if (!maskPattern) {
        return inputText;
    }

    return IMask.pipe(inputText, { mask: maskPattern });
}

/**
 * Custom masks patterns
 */
const specificMaks = {
    'creditCard': {
        mask: [
            { mask: '0000 000000 00000', cardtype: 'amex', regex: '^3[47]\\d{0,13}' },
            { mask: '0000 0000 0000 0000', cardtype: 'visa', regex: '^4\\d{0,15}' },
            { mask: '0000 0000 0000 0000', cardtype: 'mastercard', regex: '^(5[1-5]\\d{0,2}|22[2-9]\\d{0,1}|2[3-7]\\d{0,2})\\d{0,12}' },
            { mask: '0000 0000 0000 0000', cardtype: 'default' }
        ],
        dispatch: (appended, dynamicMasked) => {
            const value = (dynamicMasked.value + appended).replace(/\D/g, '');
            return dynamicMasked.compiledMasks.find((element) => value.match(element.regex));
        }
    },
    'number': { mask: Number, scale: 0, signed: false, thousandsSeparator: '' }
};


export { maskInput, maskValue }